// extracted by mini-css-extract-plugin
export default {"ProfilePage":"ProfilePage_ProfilePage__Uvn-F"};